"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skylight = void 0;
const Component_1 = require("./Component");
class Skylight extends Component_1.Component {
    static open() {
        return {
            intended: {
                s: { state: 'open' },
            },
            futureReported: {
                s: { state: 'idle' },
            },
        };
    }
    static close() {
        return {
            intended: {
                s: { state: 'close' },
            },
            futureReported: {
                s: { state: 'idle' },
            },
        };
    }
    static stop() {
        return {
            intended: {
                s: { state: 'stop' },
            },
            futureReported: {
                s: { state: 'idle' },
            },
        };
    }
}
exports.Skylight = Skylight;
//# sourceMappingURL=Skylight.js.map